import ExportTable from './ExportTable.vue';

export default ExportTable;
